import Block from '../blots/block.js';
let Blockquote = /*#__PURE__*/(() => {
  class Blockquote extends Block {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
  }
  return Blockquote;
})();
export default Blockquote;
